// extracted by mini-css-extract-plugin
export default {"target":"item_target__dou+A","info":"item_info__BJSYr","logo":"item_logo__MRMMN","counter":"item_counter__W2uXN","labels":"item_labels__yUfkd","label":"item_label__lbn3A"};